var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19298 6.80701L57.193 62.807C57.8947 63.5789 58.8772 64 60 64C62.1754 64 64 62.1754 64 60C64 58.8772 63.5789 57.8947 62.807 57.193L6.80702 1.19298C6.10526 0.421051 5.12281 0 4 0C1.82456 0 0 1.82456 0 4C0 5.1228 0.421052 6.10526 1.19298 6.80701ZM57.193 1.19298L1.19298 57.193C0.421052 57.8947 0 58.8772 0 60C0 62.1754 1.82456 64 4 64C5.12281 64 6.10526 63.5789 6.80702 62.807L62.807 6.80701C63.5789 6.10526 64 5.1228 64 4C64 1.82456 62.1754 0 60 0C58.8772 0 57.8947 0.421051 57.193 1.19298Z",
    fill: "#191404"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e3dbcb36.svg";
export { ForwardRef as ReactComponent };